module.exports = __webpack_public_path__ + "img/Annotated_Mages_Dungeon_Map.ac793a10.png";